import $ from 'jquery';
import 'scroll-depth';

import trackEvent from '@99designs/utils/platform/trackEvent';
import trackLink from '@99designs/utils/platform/trackLink';

import riveted from 'common/libs/riveted.min';
import { findParentByAttribute, getLinkTargetUrl, getLinkTargetPath } from 'common/utils/domUtils';

const TRACKABLE_SECTION_ATTRIBUTE = 'data-trackable-section';
const TRACKABLE_CLICK_EVENT_ATTRIBUTE = 'data-trackable-click-event';

export default class UserBehaviourTracking {
    constructor() {
        this.trackElementScrollLeft = this.trackElementScroll.bind(this, 'left');
        this.trackElementScrollRight = this.trackElementScroll.bind(this, 'right');

        this.setupTrackLink(document.querySelectorAll('a'));
        this.setupTrackableClickEvent();
        this.setupScrollDepthTracking();
        this.setupActiveTimeTracking();
        this.setupScrollableTracking();
    }

    setupTrackLink(links) {
        Array.from(links)
            .filter(link => !link.getAttribute('data-scrollto'))
            .forEach(link => {
                const defaultData = getDefaultTrackingData(link);
                const targetUrl = getLinkTargetUrl(link);
                const targetPath = getLinkTargetPath(link);

                trackLink(link, 'Clicked Link On Product Page', Object.assign({}, defaultData, {
                    target_url: targetUrl,
                    target_path: targetPath,
                }));
            });
    }

    setupTrackableClickEvent() {
        const clickables = document.querySelectorAll(`[${TRACKABLE_CLICK_EVENT_ATTRIBUTE}]`);

        Array.from(clickables)
            .forEach(clickable => {
                clickable.addEventListener('click', (e) => {
                    const defaultData = getDefaultTrackingData(clickable);

                    trackEvent('Clicked Element On Product Page', Object.assign({}, defaultData, {
                        element_id: clickable.getAttribute(TRACKABLE_CLICK_EVENT_ATTRIBUTE),
                    }));
                });
            });
    }

    setupScrollDepthTracking() {
        const globalTrackParams = global.trackParams || {};

        $.scrollDepth({
            percentage: true,
            userTiming: false,
            pixelDepth: false,
            nonInteraction: false,
            elements: [
                '[data-trackable-section="main-nav"]',
                '[data-trackable-section="product-hero"]',
                '[data-trackable-section="featured-contests-carousel"]',
                '[data-trackable-section="product-features"]',
                '[data-trackable-section="how-it-works"]',
                '[data-trackable-section="customer-examples"]',
                '[data-trackable-section="customer-testimonial"]',
                '[data-trackable-section="star-rating"]',
                '[data-trackable-section="pricing"]',
                '[data-trackable-section="product-pair"]',
                '[data-trackable-section="freelance-designers"]',
                '[data-trackable-section="faqs"]',
                '[data-trackable-section="related-categories"]',
                '[data-trackable-section="page-links"]',
                '[data-trackable-section="press-link-list"]',
                '[data-trackable-section="footer-nav"]',
            ],
            eventHandler: (data) => {
                let sectionId = null;
                let eventName = `Scrolled Product Page To ${data.eventLabel}`
                const sectionMatch = data.eventLabel.match(/data-trackable-section="(.+)"/);

                if (sectionMatch && sectionMatch[1]) {
                    eventName = 'Scrolled Product Page To Section';
                    sectionId = sectionMatch[1];
                }

                trackEvent(eventName, Object.assign(globalTrackParams, {
                    page_height: $(document).height(),
                    section_id: sectionId,
                }));
            }
        });
    }

    setupActiveTimeTracking() {
        let pageLoadTime = null;
        const trackableTimes = [5, 10, 15, 20, 25, 30]; // in seconds
        const globalTrackParams = global.trackParams || {};

        if (performanceIsAvailable()) {
            pageLoadTime = (new Date()).getTime() - window.performance.timing.navigationStart;
        }

        riveted.init({
            eventHandler: activeTime => {
                if (trackableTimes.includes(activeTime) || activeTime % 30 === 0) {
                    trackEvent('Engaged On Product Page', Object.assign(globalTrackParams, {
                        active_time_in_seconds: activeTime,
                        page_load_time: pageLoadTime,
                    }))
                }

                if (activeTime >= 300) {
                    riveted.off();
                }
            }
        });
    }

    setupScrollableTracking() {
        const elements = document.querySelectorAll('[data-scrollable-inner]');

        Array.from(elements)
            .forEach(el => {
                el.addEventListener('scroll', this.trackElementScrollLeft);
                el.addEventListener('scroll', this.trackElementScrollRight);
            });
    }

    trackElementScroll(position, e) {
        const threshold = 300;
        const scrollLeft = e.target.scrollLeft;
        const scrollRange = e.target.scrollWidth - e.target.offsetWidth;
        const isLeftEdge = position === 'left' && scrollLeft <= 0 + threshold;
        const isRightEdge = position === 'right' && scrollLeft >= scrollRange - threshold;

        if (isLeftEdge) {
            const defaultData = getDefaultTrackingData(e.target);

            e.target.removeEventListener('scroll', this.trackElementScrollLeft);

            trackEvent('Scrolled Element To Side On Product Page', Object.assign({}, defaultData, {
                element_scroll_position: position,
            }));
        } else if (isRightEdge) {
            const defaultData = getDefaultTrackingData(e.target);

            e.target.removeEventListener('scroll', this.trackElementScrollRight);

            trackEvent('Scrolled Element To Side On Product Page', Object.assign({}, defaultData, {
                element_scroll_position: position,
            }));
        }
    }
}

function getDefaultTrackingData(node) {
    const globalTrackParams = global.trackParams || {};
    const parent = findParentByAttribute(node, TRACKABLE_SECTION_ATTRIBUTE);
    const sectionId = parent ? parent.getAttribute(TRACKABLE_SECTION_ATTRIBUTE) : null;

    return Object.assign(global.trackParams, {
        section_id: sectionId,
    });
}

function performanceIsAvailable() {
    return window.performance && typeof window.performance.timing === 'object';
}



// WEBPACK FOOTER //
// ./js/marketing/utils/UserBehaviourTracking.js